import React from 'react';
import autobind from 'autobind-decorator';
import { inject, observer } from 'mobx-react';

import NewSongModal from './new-song-modal';
import SongList from './song-list';

@inject('songsStore', 'artistStore')
@observer
class Music extends React.Component {
	constructor (props) {
		super(props);

		this.props = props;

		const { artistStore, userID } = this.props;
		this.artist = artistStore.getArtistByUserID(userID);
	}

	render () {
		const { songsStore, optionsTheme, trackListMode = false, tracksList = 'trackList', songList = [] } = this.props;

		if (songsStore.isLoading) {

			return <h1>Loading...</h1>;
		}

		return (
			<div onClick={ this.onClick }>
				{ this.renderMusicModal() }

				<div className="grid-x">
					<div className="cell small-12 full-preview-list">
						<SongList
							trackListMode
							artist={ this.artist }
							listKey="fullPreviewList"
							optionsTheme={ optionsTheme }
						/>
					</div>
				</div>
				<div className="grid-x">
					<div className="cell">&nbsp;</div>
				</div>
				<div className="grid-x">
					<div className="cell small-12">
						<SongList
							trackListMode
							artist={ this.artist }
							listKey="tracksList"
							songList={ songList }
							optionsTheme={ optionsTheme }
						/>
					</div>
				</div>
			</div>
		);
	}

	renderMusicModal () {
		const { trackListMode } = this.props;

		if (trackListMode) {

			return null;
		}

		return (
			<div className="grid-x align-bottom">
				<div className="cell small-12">
					<NewSongModal artist={ this.artist } />
				</div>
			</div>
		);
	}

	@autobind
	onClick ({ target: { classList } }) {
		if (classList.contains('button') || classList.contains('delete-button-container')) {

			return;
		}

		const { songsStore } = this.props;
		songsStore.activeSongRowID = null;
	}
}

export default Music;
